import styled, { createGlobalStyle } from 'styled-components';
import KineduLogo from '../KineduLogo';
import signInImage from '../assets/images/educators_devices.png';
import signUpImage from '../assets/images/shapes_background.png';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 10px !important;
  }
`;

const View = styled.div``;

const Left = styled.div`
  position: absolute;
  display: none;
  left: 0;
  top: 0;
  bottom: 0;
  width: 50%;
  z-index: 1;

  ${({ theme }) => `
  background-color: ${theme?.colors?.primary};
    ${theme.breakPoints.tablet} {
      display: block;
    }
  `}

`;

const Right = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 1;
  background-color: #fff;

  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      width: 50%;
    }
  `}
`;

const Image = styled.img.attrs(() => ({
  src: signInImage,
  alt: 'Sign In',
}))`
  width: calc(100% + 80px);
  position: relative;
`;

const Navbar = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 45px 20px;
  align-items: center;
`;

const Languages = styled.div`
  display: flex;
  margin-left: 5px;
`;

const ViewContainer = styled.div`
  max-width: 1060px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  z-index: 2;
  position: relative;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      grid-template-columns: repeat(2, 1fr);
    }
  `}
`;

const LeftSection = styled.div.attrs(() => ({
  className: 'LeftSection',
}))`
  position: relative;
  width: 100%;
  align-items: center;
  flex: 1;
  display: none;
  padding: 20px;
  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      padding: 40px;
      width: 100%;
      display: block;
    }
  `}
`;

const RightSection = styled.div`
  width: 100%;
  align-items: center;
  padding: 0px;
  max-width: 407px;
  margin: 0 auto;
  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      width: 100%;
      max-width: 100%;
      margin: 0 auto;
    }
  `}
`;

const LanguageButton = styled.div`
  margin: 1px;
  cursor: pointer;
  ${({ theme }) => `
    ${theme.breakPoints.largePhone} {
      margin: 3px;
    }
  `}
`;

// eslint-disable-next-line no-undef
const BtnCircle = styled.div<any>`
  width: 26px;
  height: 26px;
  font-size: 1.2rem;
  border-radius: 50%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme, selected }) => `
    border: 1px solid ${theme.colors.primary};
    color: ${theme.colors.primary};
    ${
      selected
        ? `
      background-color: ${theme?.colors?.primary};
      color: #fff;
      font-weight: 600;
    `
        : ''
    }

    ${theme.breakPoints.largePhone} {
      width: 34px;
      height: 34px;
      font-size: 12px;
    }
  `}
`;

const FormContainer = styled.div`
  padding: 20px;
  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      max-width: 410px;
      margin: 0px 80px;
      width: 100%;
    }
 `}
`;

const DefaultKineduLogo = styled(KineduLogo).attrs(() => ({
  variant: 'default',
}))`
  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      display: none;
    }
  `}
`;

const WhiteKineduLogo = styled(KineduLogo).attrs(() => ({
  variant: 'white',
}))`
  width: 330px;
  height: 40px;
  display: none;
  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      display: block;
    }
  `}
`;

const TextContainer = styled.div`
  position: absolute;
  top: 70px;
  right: 0;
  width: 100%;
`;

const Title = styled.p`
  font-size: 36px;
  line-height: 1.2em;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
`;

const List = styled.ul``;

const ListItem = styled.li`
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 44px;
  margin: 2px 0px;
`;

const ImageSignup = styled.img.attrs(() => ({
  src: signUpImage,
  alt: 'Sign Up',
}))`
  width: calc(100% + 281px);
  position: relative;
  right: 127px;
`;

export {
  GlobalStyle,
  View,
  Left,
  Right,
  Image,
  Navbar,
  Languages,
  ViewContainer,
  Row,
  LeftSection,
  RightSection,
  LanguageButton,
  BtnCircle,
  FormContainer,
  DefaultKineduLogo,
  WhiteKineduLogo,
  TextContainer,
  Title,
  List,
  ListItem,
  ImageSignup,
};
